import {Card} from "@mantine/core";
import type {ReactNode} from "react";

import classes from "./InfoCard.module.scss";

export interface InfoCardProps {
  title?: string;
  children: ReactNode;
}

export default function InfoCard({title, children}: InfoCardProps) {
  return (
    <Card
      classNames={{root: classes.infoCard}}
      withBorder
      padding="md"
      radius="md">
      {title && (
        <Card.Section>
          <div className={classes.infoCardHeader}>{title}</div>
        </Card.Section>
      )}
      {children}
    </Card>
  );
}
